"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const Divider_1 = __importDefault(require("../Divider/Divider"));
require("./index.css");
const Sidebar = (props) => {
    const { headerTitle, sidebarContent, headerSubtitle, width, onLogout } = props;
    return (React.createElement("div", { className: "sidebar_container", style: { width: width ? width : "" } },
        React.createElement("div", { className: "sidebar_content_container" },
            onLogout && (React.createElement("div", { className: "sidebar_logout", onClick: () => onLogout() }, "Logout")),
            React.createElement("div", { className: "sidebar_header" },
                React.createElement("h3", null, headerTitle),
                headerSubtitle && React.createElement("p", null, headerSubtitle)),
            React.createElement(Divider_1.default, null),
            React.createElement("div", { className: "sidebar_content" }, sidebarContent))));
};
exports.default = Sidebar;
//# sourceMappingURL=Sidebar.js.map